import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import TertiaryTopRoundButton from "../../../../components/_utils/CommonButtons/TertiaryTopRoundButton/TertiaryTopRoundButton";
import CommonCardDashboard from "../../../../components/_utils/CommonCardDashboard";
import QuickActionCard from "../../../../components/QuickActionCard/QuickActionCard";
import {
  beneInternalDashboard,
  resetInternalToggle,
} from "../../../../redux/features/internalApi/internalApi";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import "./index.css";

const InternalAccountDashboard = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { beneInternalDashboardAccData, beneInternalDashboardAccLoading } =
    useSelector((state) => state.internalAcc);

  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const summary = beneInternalDashboardAccData?.summary || {};

  const approvedValue =
    summary?.approved_accounts_count ??
    GlobalConfiguration.dashboardPrimaryCount;

  const pendingValue =
    summary?.pending_accounts_count ??
    GlobalConfiguration.dashboardPrimaryCount;

  const canViewAll =
    services?.includes("IVAccount") ||
    services?.includes("MimicEntity") ||
    services?.includes("Admin");

  const totalCount =
    beneInternalDashboardAccData?.total_count ??
    GlobalConfiguration?.lengthCheckZero;

  const isViewAllDisabled =
    !canViewAll ||
    beneInternalDashboardAccLoading ||
    totalCount === GlobalConfiguration?.lengthCheckZero;

  useEffect(() => {
    dispatch(enableSwitcher());

    dispatch(beneInternalDashboard({ page: 1, page_size: 50 }));

    return () => dispatch(disableSwitcher());
  }, [dispatch, props?.internalAccount, markerData]);

  const handleDatacardClick = (approvalStatus) => {
    const routeMap = {
      approved: "/internal_account_dashboard/internal_account_view_all",
      pending:
        services.includes("IAAccount") || services?.includes("Admin")
          ? "/internal_account_dashboard/internal_account_approval"
          : (services.includes("IVAccount") || services?.includes("Admin")) &&
              !services.includes("IAAccount")
            ? "/internal_account_dashboard/internal_account_view_all"
            : navigate("/feature_not_assigned", {
                state: {
                  unavailableService: "IAAccount",
                },
              }),
    };
    dispatch(resetInternalToggle());
    navigate(routeMap[approvalStatus], {
      state: { approvalStatus },
    });
  };

  return (
    <div className=" internalDashboardView bg-primary-bg w-width-full px-padding-md overflow-y-auto lg:px-padding-base pb-padding-md  h-screen ">
      <div className="Qsmd:h-navbar-breadcrumb-height"></div>
      <div className="flex flex-col gap-x-gap-md mt-margin-md lg:mx-auto pb-padding-xl lg:pb-padding-base max-w-tab-width-normal w-width-full Qlg:flex-row mb-margin-xl lg:mb-margin-base Qlg:relative">
        <div className="Qlg:w-dashboard-left-card-width">
          <div className="w-width-full flex flex-col pt-padding-md Qsmd:pt-padding-base mt-margin-xl Qsmd:mt-margin-base ">
            <div className="w-width-full p-padding-sm fixed top-top-base left-left-base right-right-base bg-text-primary flex items-center z-z-index-tooltip Qlg:hidden rounded-bl-border-radius-sm rounded-br-border-radius-sm">
              <div className="flex flex-row items-center">
                <img
                  src={ICONS?.INTERNAL_ACCOUNT_WITH_BLUE_CIRCLE}
                  alt="INTERNAL_ACCOUNT_WITH_BLUE_CIRCLE"
                  className="h-icon-lg w-icon-lg mr-margin-sm"
                />
                <div className="flex flex-col">
                  <div className="flex items-center">
                    <p className="text-primary-bg font-semibold text-font-md">
                      Internal
                    </p>
                  </div>
                  <p className="text-primary-bg text-font-xs">Accounts</p>
                </div>
              </div>
            </div>
            <div className="w-width-full rounded-border-radius-md relative overflow-hidden">
              <h2 className="bg-primary-card flex items-center justify-between pl-padding-md transition-all duration-animation-medium">
                <div className="flex items-center gap-gap-sm">
                  <img
                    src={ICONS?.APPROVAL_STATUS}
                    alt="transaction header"
                    className="w-icon-sm h-icon-sm"
                  />
                  <p className="text-font-sm font-semibold font-sans text-text-primary">
                    Account statuses
                  </p>
                </div>
                <div className="flex">
                  <div className="border-dividing"></div>
                  <TertiaryTopRoundButton
                    btnText="View all"
                    icon={ICONS?.ARROW_RIGHT_WHITE}
                    imgColor="var(--text-primary)"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={async () => {
                      if (isViewAllDisabled) return;

                      await dispatch(resetInternalToggle());
                      navigate(
                        "/internal_account_dashboard/internal_account_view_all",
                      );
                    }}
                    isDisabled={isViewAllDisabled}
                    enabledTextColor={"var(--text-primary)"}
                    enabledBgColor={"var(--primary-card)"}
                    disabledBgColor={"transparent"}
                  />
                </div>
              </h2>
              <div>
                <div className="flex flex-col Qsmd:flex-row gap-gap-base p-padding-base bg-primary-nav">
                  <CommonCardDashboard
                    label={
                      services?.includes("IAAccount") ||
                      services?.includes("Admin")
                        ? "Require approval"
                        : "Pending accounts"
                    }
                    count={pendingValue ?? "00"}
                    color="var(--pending)"
                    loader={beneInternalDashboardAccLoading}
                    onClick={() => handleDatacardClick("pending")}
                  />

                  <div className="border-border border-primary-bg Qsmd:my-margin-md my-margin-base"></div>
                  <CommonCardDashboard
                    label="Approved accounts"
                    count={
                      services?.includes("IVAccount") ||
                      services?.includes("Admin")
                        ? approvedValue
                        : "N/A"
                    }
                    color="var(--awaiting)"
                    loader={beneInternalDashboardAccLoading}
                    onClick={() => handleDatacardClick("approved")}
                    onServiceUnavailable={() =>
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "IVAccount" },
                      })
                    }
                  />
                </div>
              </div>
            </div>

            <div className="w-width-full mt-margin-md bg-primary-card rounded-t-border-radius-md rounded-b-border-radius-md">
              <h2 className="flex items-center justify-between px-padding-md py-padding-sm text-sm font-semibold text-text-secondary transition-all duration-animation-medium rounded-t-border-radius-md">
                <span className="flex items-center text-sm font-semibold text-text-primary ">
                  <img
                    src={ICONS?.STATISTICS}
                    alt="Statistics Header"
                    className="w-icon-sm h-icon-sm mr-margin-sm"
                  />
                  Statistics
                </span>
              </h2>
              <div className="border-border border-primary-bg mx-margin-md"></div>

              <div className="relative w-width-full lg:py-padding-md overflow-hidden contents lg:block ">
                <div className="flex flex-col items-center justify-center lg:justify-start h-height-full text-center p-padding-md">
                  <div className="flex flex-col justify-center items-center w-width-full">
                    <img
                      src={ICONS?.NO_STATISTICS}
                      alt="No Slides"
                      className="mb-margin-sm"
                    />
                    <p className="text-font-xs text-text-primary">
                      No statistics available due to the absence of data. Once
                      data is present,
                      <br />
                      statistics will appear.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="Qlg:w-dashboard-right-card-width">
          <QuickActionCard
            title="More actions"
            labels="MIS report"
            onClick={() => {
              if (!services?.includes("SMisUser")) {
                navigate("/feature_not_assigned", {
                  state: { unavailableService: "SMisUser" },
                });
                return;
              }

              navigate("/internal_account_dashboard/generate_mis_report");
            }}
            labelDisabled={!services?.includes("SMisUser")}
          />
        </div>
      </div>
    </div>
  );
};

export default InternalAccountDashboard;
